import { useLocation } from "react-router-dom";
import {
  storyblokEditable,
  StoryblokComponent,
  useStoryblok,
} from "@storyblok/react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";
import "./book.scss";
import { optimizeImage } from "../../helpers/storyblokImage";
import { useDelayedLoading } from "../../helpers/useDelayedLoading";

const Deepdive = () => {
  const location = useLocation();
  // Storyblok's full_slug bevat het folderpad (bv. "trainingen/boeknaam"),
  // dus we geven het hele pad door, niet alleen het laatste segment.
  const fullSlug = location.pathname.replace(/^\/+/, "");
  const story = useStoryblok(fullSlug, { version: "draft" });
  // useStoryblok begint met een leeg object ({}), niet null/undefined, dus
  // we bepalen "geladen" aan de hand van story.content i.p.v. story zelf.
  const blok: any = story?.content;
  const hasContent = Boolean(blok);
  const showLoading = useDelayedLoading(!hasContent, 200);
  const showNotFound = useDelayedLoading(!hasContent, 3000);

  if (!hasContent) {
    if (showNotFound) return <div>Pagina niet gevonden</div>;
    return showLoading ? <div>Loading...</div> : null;
  }

  const image = blok.body[0].image;
  const path = image ? image.filename : "";
  const alt = image ? image.alt : "";
  const fullscreen = blok.body[0].fullscreen;
  const bgColorLeft = blok.body[0].bgLeftSide;

  return (
    <main {...storyblokEditable(blok)} className="page-book">
      <div className={`left ${bgColorLeft === "orange" ? "orange" : "pink"} `}>
        {path ? (
          <LazyLoadImage
            className={`${fullscreen ? "fullscreen-image" : "image"}`}
            src={optimizeImage(path, 800)}
            alt={alt}
            effect="opacity"
            width={100 + "%"}
            height={100 + "%"}
            wrapperClassName="wrapper"
          />
        ) : (
          ""
        )}
      </div>
      <div className="right">
        {blok.body
          ? blok.body.map((blok: any) => (
              <StoryblokComponent blok={blok} key={blok._uid} />
            ))
          : null}
      </div>
    </main>
  );
};
export default Deepdive;
